export type InventoryStatus = 'Allocated' | 'AwaitingShipment' | 'Failed' | 'InStock' | 'InternalAsset' | 'ToBeInspected' | 'ToBeInspected-RMA' | 'InUse';

export interface StatusOption {
  value: InventoryStatus;
  label: string;
}

export const STATUS_OPTIONS: StatusOption[] = [
  { value: 'Allocated', label: 'Allocated' },
  { value: 'AwaitingShipment', label: 'Awaiting Shipment' },
  { value: 'Failed', label: 'Failed' },
  { value: 'InStock', label: 'In Stock' },
  { value: 'InternalAsset', label: 'Internal Asset' },
  { value: 'ToBeInspected', label: 'To Be Inspected' },
  { value: 'ToBeInspected-RMA', label: 'To Be Inspected - RMA' },
  { value: 'InUse', label: 'In Use' },
];

export interface UserSummary {
  id: number;
  name: string;
}

export interface Item {
  id: number;
  part_number: string;
  description: string;
  sku: string;
}

export interface Inventory {
  id: number;
  serial_number: string;
  status: string;
  grade: string;
  user_id: number;
  previous_location: string;
  previous_location_date: string;
  item: Item;
}

export interface InventoryByUserResponse {
  quantity: number;
  inventory: Inventory[];
}

export interface InventoryFiltersForm {
  userId: string;
  statuses: InventoryStatus[];
}
